import styled from 'styled-components';
import bg from '../../assets/bg.jpg';

export const AuthWrapper = styled('div')`
    background-image: url('${bg}');
    background-position-x: center;
    background-position-y: center;
    background-size: cover;
    background-attachment: fixed;
    background-origin: initial;
    background-clip: initial;
    background-color: initial;
    height: 100vh;
    display: flex;
    overflow-x: hidden !important;
`;

export const FormWrapper = styled('div')`
width: ${props => props.isMobile ? "360px" : "480px"} ;
padding: 50px;
border-radius: 15px;
overflow-x: hidden !important;

`;